import { motion } from "framer-motion";
import SectionHeading from "../../SectionHeading";
import { fadeUp, revealOnce, stagger } from "../../motion";
import "../../css/Companies.css";

const COMPANIES = [
  { name: "CWG PLC", domain: "cwg-plc.com", href: "https://cwg-plc.com" },
  { name: "Summitech Computing Limited", domain: "summitech.io", href: "https://summitech.io" },
  { name: "Netcom Africa Limited", domain: "netcomafrica.com", href: "https://netcomafrica.com" },
  { name: "Tekktopia Limited", domain: "tekktopia.com", href: "https://tekktopia.com" },
  { name: "Cribxpert Limited", domain: "cribxpert.com", href: "https://cribxpert.com" },
];

const Companies = () => {
  return (
    <section className="section companies">
      <div className="container">
        <SectionHeading
          eyebrow="Experience"
          title="Companies I've worked with"
        />

        <motion.ul className="companies__list" variants={stagger} {...revealOnce}>
          {COMPANIES.map((company) => {
            const content = (
              <span className="company__info">
                <span className="company__name">{company.name}</span>
                {company.domain && (
                  <span className="company__domain">{company.domain}</span>
                )}
              </span>
            );

            return (
              <motion.li key={company.name} className="company" variants={fadeUp}>
                {company.href ? (
                  <a href={company.href} target="_blank" rel="noopener noreferrer">
                    {content}
                    <span className="company__arrow" aria-hidden="true">↗</span>
                  </a>
                ) : (
                  <span className="company__static">{content}</span>
                )}
              </motion.li>
            );
          })}
        </motion.ul>
      </div>
    </section>
  );
};

export default Companies;
